import axios from "axios";
import { setAuthHeader } from "app/services/auth.header.service";
import {
    getUrlForUnifiedEfforts,
    getUrlForUnifiedEffortsMonthly,
    getUrlForUnifiedLeave,
} from "utils/endpointUtils/unifiedEffortsEndpointUtil";

/**
 * Leave plans over the same scope as the effort reads, replacing the four role-specific
 * /leave-plans/by-* endpoints. Returns the LeavePlan shape the leave grid already consumes.
 * @since NEXT_VERSION
 */
export const loadUnifiedLeave = async (filter) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");

    return await axios.get(getUrlForUnifiedLeave(filter), config);
};

/**
 * The unified consolidated-effort read. One call, every filter applied server-side.
 *
 * Replaces the per-role loaders below, each of which hit a different endpoint with a different
 * subset of filters and then re-filtered the response in the browser.
 *
 * @param filter { fromDate, toDate, managerId, includeSubtree, clientIds, ownerId, ownerType,
 *                 effortTypes } — every field optional except the dates.
 * @since NEXT_VERSION
 */
export const loadUnifiedEfforts = async (filter) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");

    return await axios.get(getUrlForUnifiedEfforts(filter), config);
};

/**
 * The same scope rolled up to one row per owner per month, for the efforts-summary card.
 * Defaults server-side to activities only.
 * @since NEXT_VERSION
 */
export const loadUnifiedEffortsMonthly = async (filter) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");

    return await axios.get(getUrlForUnifiedEffortsMonthly(filter), config);
};
